import { render } from "./PantryOptionAxisPage.vue?vue&type=template&id=c295c66e&ts=true"
import script from "./PantryOptionAxisPage.vue?vue&type=script&lang=ts"
export * from "./PantryOptionAxisPage.vue?vue&type=script&lang=ts"

import "./PantryOptionAxisPage.vue?vue&type=style&index=0&id=c295c66e&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__